module.exports = __webpack_public_path__ + "img/topic.dc6c058c.png";